import { styled } from 'styled-components';
import Box from '../atoms/Box';

const Content = styled(Box)`
  flex: 1;
  width: 98%;
  margin: 10px;
  margin-bottom: 30px;
`;

export default Content;
